/*
 * value creates the window function updateStringValues
 *
 * The function is used whenever a virtualpage change takes place.
 * The function is used in situations when a user wants to display a filled in value, generally one that isn't posted yet.
 * If a value exists, the text will be overwritten.
 * If a value does not exist, the fallback inside the span will remain.
 */

function updateStringValues() {
  $('[data-put-value]').each(function iterator() {
    const name = $(this).data('put-value');
    let value = '';

    switch ($(`[name=${name}]`).attr('type')) {
    case 'text':
      value = $(`[name=${name}]`).length > 0 ? $(`[name=${name}]`).val() : '';
      break;
    case 'checkbox':
      if ($(`[name=${name}]:checked`).length > 0) {
        const id = $(`[name=${name}]:checked`).attr('id');
        const text = $(`label[for=${id}]`).text();
        if (text !== '') {
          value = text;
        }
      }
      break;
    case 'radio':
      if ($(`[name=${name}]:checked`).length > 0) {
        const id = $(`[name=${name}]:checked`).attr('id');
        const text = $(`label[for=${id}]`).text();
        if (text !== '') {
          value = text;
        }
      }
      break;
    default:
      value = $(`[name=${name}]`).length > 0 ? $(`[name=${name}]`).val() : '';
    }

    if (value !== '') {
      $(this).text(value);
    }
  });
}

export default updateStringValues;
